/* LBL Lichter, tekstpagina's (24 okt 2026). Zet regels die met <br> onder elkaar staan en met een streepje, vinkje of vet label beginnen
   om in een rustige lijst (gouden streepje, label boven toelichting). Alleen opmaak in de browser; de paginatekst in Shopify blijft ongewijzigd.
   Zonder JS blijft de tekst gewoon leesbaar. */
(function () {
  var MARK = /^\s*(?:[–—\-•·]|[✔✓✅☑])\s*/;
  function lineText(ln) { return ln.map(function (n) { return n.textContent; }).join('').replace(/\s+/g, ' ').trim(); }
  function leadBold(ln) {
    for (var i = 0; i < ln.length; i++) {
      var n = ln[i];
      if (n.nodeType === 3 && !n.textContent.replace(/[\s ✔✓✅☑–—\-•·]/g, '')) continue;
      if (n.nodeType !== 1) return null;
      var b = (n.nodeName === 'B' || n.nodeName === 'STRONG') ? n : n.querySelector('b, strong');
      return b && n.textContent.trim().indexOf(b.textContent.trim()) === 0 ? b : null;
    }
    return null;
  }
  function isItem(ln) { var t = lineText(ln); return !!t && (MARK.test(t) || (leadBold(ln) && / [–—-] /.test(t))); }
  function run() {
    var prose = document.querySelector('.shopify-section--main-page .prose');
    if (!prose) return;
    Array.prototype.slice.call(prose.querySelectorAll(':scope > p')).forEach(function (p) {
      if (!p.querySelector('br')) return;
      var lines = [[]];
      Array.prototype.forEach.call(p.childNodes, function (n) { if (n.nodeName === 'BR') lines.push([]); else lines[lines.length - 1].push(n); });
      lines = lines.filter(function (l) { return lineText(l); });
      var items = lines.filter(isItem);
      if (items.length < 2) return;
      var frag = document.createDocumentFragment(), intro = [], ul = document.createElement('ul');
      ul.className = 'lbl-lijst';
      lines.forEach(function (ln) {
        if (!isItem(ln)) {
          if (!ul.children.length) { intro.push(ln); return; }
          var li = ul.lastChild; li.appendChild(document.createTextNode(' ')); ln.forEach(function (n) { li.appendChild(n); }); return;
        }
        var li = document.createElement('li');
        var b = leadBold(ln), label = b ? b.textContent.trim() : '';
        var html = ln.map(function (n) { return n.nodeType === 3 ? n.textContent : n.outerHTML; }).join('');
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        tmp.innerHTML = tmp.innerHTML.replace(/^\s*(?:[–—\-•·]|[✔✓✅☑])\s*/, '');
        if (b) {
          var lead = tmp.querySelector('b, strong');
          var k = document.createElement('span'); k.className = 'lbl-lijst__k'; k.textContent = lead.textContent.trim();
          var rest = document.createElement('span'); rest.className = 'lbl-lijst__t';
          var par = lead.parentNode; (par !== tmp && par.textContent.trim() === lead.textContent.trim()) ? par.remove() : lead.remove();
          rest.innerHTML = tmp.innerHTML.replace(/^\s*[–—-]\s*/, '');
          li.appendChild(k); if (rest.textContent.trim()) li.appendChild(rest);
        } else { while (tmp.firstChild) li.appendChild(tmp.firstChild); }
        ul.appendChild(li);
      });
      if (intro.length) {
        var ip = document.createElement('p');
        intro.forEach(function (ln, i) { if (i) ip.appendChild(document.createElement('br')); ln.forEach(function (n) { ip.appendChild(n); }); });
        frag.appendChild(ip);
      }
      frag.appendChild(ul);
      p.replaceWith(frag);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* Pagina's zonder h1 (sectiepagina's met een koptekst als <p class="h1"> of <h2>): de eerste kop krijgt de rol van hoofdkop (toegankelijkheid en
   zoekmachines), zonder de zichtbare opmaak te veranderen. Alleen als de pagina nog geen h1 heeft. */
(function () {
  function fix() {
    var main = document.getElementById('main');
    if (!main || main.querySelector('h1,[role="heading"][aria-level="1"]')) return;
    var cand = main.querySelector('.h1, h2, .h2');
    if (!cand) return;
    cand.setAttribute('role', 'heading');
    cand.setAttribute('aria-level', '1');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix); else fix();
})();
